import HooksModalV5Key from "app/constants/HooksModalV5Key";
import type { GainAccessButtonProps } from "./GainAccessButton";
import { GainAccessButton } from "./GainAccessButton";
import { handleCTAClick, TestCases } from "app/common/utils/handleGainAccessRedirect";
import { EHooksVersions } from "app/services/SwHook";

function GetMoreResultsSalesSolution(props: GainAccessButtonProps) {
    const handleButtonClick = () => {
        handleCTAClick(EHooksVersions.V5, HooksModalV5Key.SalesSolutionDefault, TestCases.TRIAL_AFTER_TRIAL);
    };

    return (
        <div>
            <GainAccessButton
                {...props}
                isExploreOurPackages={true}
                onClick={handleButtonClick}
            />
        </div>
    );
}

export default GetMoreResultsSalesSolution;
